export default function Title({ txt, color, txtColor }) {
  return (
    <div>
      <div className="d-flex">
        {" "}
        <div
          style={{
            backgroundColor: color,
            color: txtColor,
            padding: `5px 10px 5px 0`,
          }}
        >
          {txt}
        </div>
        <div
          style={{
            width: 20,
            height: 35,
            backgroundImage: `linear-gradient(to bottom right, transparent 50%, red 0)`,
            // backgroundSize: "50% 100%",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "left, right",
          }}
        />
      </div>
      <div className="d-flex">
        <div style={{ height: 4, backgroundColor: color }} className="w-100" />
        <div
          style={{
            width: 5,
            height: 4,
            backgroundImage: `linear-gradient(to bottom right, transparent 50%, red 0)`,
            // backgroundSize: "50% 100%",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "left, right",
          }}
        />
      </div>
    </div>
  );
}
